<template>
  <span class="display-none"></span>
</template>

<script>

export default {
  name: 'NotificationConversationListItem',
  props: ['conversation', 'conversationSelected'],
  computed: {
    hasUnread() {
      return this.unreadCount > 0;
    },
    conversationUrl() {
      return `/conversations/${this.conversation.id}`;
    },
    isCurrent() {
      return this.conversation.id === this.conversationSelected;
    },
    unreadCount() {
      return this.conversation.customer_messages_unread_count;
    },
  },
  methods:{
    notifyNewConversation() {
      if ((!this.isCurrent || this.$root.pageHidden) && this.$root.agentDashboardSettings.attributes['notifications-level'] === 'all') {
        let audio = new Audio(require('@/assets/notify2.wav'));
        audio.play();
      }
      if (this.$root.pageHidden && this.$root.agentDashboardSettings.attributes['notifications-level'] !== 'disabled') {
        this.displayBrowserNotification();
      }
    },
    displayBrowserNotification() {
      let text = this.conversation.latest_customer_message.text;
      let author = this.conversation.customer.attributes.name;
      let message = this.$t('conversation.newMessage', {author: author});
      this.$notification.show(message, {
        body: text,
      }, {
        onclick: () => {
          window.location.href = this.conversationUrl;
        },
      });
    },
  },
  watch: {
    unreadCount(newValue, oldValue) {
      if (newValue && newValue > oldValue) {
        this.notifyNewConversation();
      }
    },
  }
}
</script>
